class NovieexNavigation extends HTMLElement {
  connectedCallback() {
    this.triggers = [...this.querySelectorAll('.novieex-navigation__trigger')];
    this.backdrop = this.querySelector('.novieex-navigation__backdrop');
    this.abortController = new AbortController();
    const signal = this.abortController.signal;

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => this.toggle(trigger), { signal });
      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          this.open(trigger, true);
        }
      }, { signal });
    });
    this.backdrop?.addEventListener('click', () => this.close(true), { signal });

    const closeFromOutside = (event) => {
      if (!this.contains(event.target)) this.close();
    };
    document.addEventListener('pointerdown', closeFromOutside, { signal, capture: true });
    document.addEventListener('click', closeFromOutside, { signal, capture: true });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close(true);
    }, { signal });
    this.addEventListener('focusout', (event) => {
      if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
    }, { signal });
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  toggle(trigger) {
    trigger.getAttribute('aria-expanded') === 'true' ? this.close(true) : this.open(trigger);
  }

  open(trigger, moveFocus = false) {
    this.close();
    const panel = this.querySelector(`#${CSS.escape(trigger.getAttribute('aria-controls'))}`);
    if (!panel) return;
    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    if (this.backdrop) this.backdrop.hidden = false;
    this.activeTrigger = trigger;
    if (moveFocus) panel.querySelector('a, button')?.focus();
  }

  close(returnFocus = false) {
    const trigger = this.activeTrigger;
    this.triggers?.forEach((item) => {
      item.setAttribute('aria-expanded', 'false');
      const panel = this.querySelector(`#${CSS.escape(item.getAttribute('aria-controls'))}`);
      if (panel) panel.hidden = true;
    });
    this.activeTrigger = null;
    if (this.backdrop) this.backdrop.hidden = true;
    if (returnFocus) trigger?.focus();
  }
}

if (!customElements.get('novieex-navigation')) {
  customElements.define('novieex-navigation', NovieexNavigation);
}
